export default __webpack_public_path__ + "static/emenu-presentation_kz-9f4ebb38db949b528f342166efd920dc.webp";